/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsCreateReportDefinitionMutationResponse, AuditReportsCreateReportDefinitionPathParams, AuditReportsCreateReportDefinition400, AuditReportsCreateReportDefinition401, AuditReportsCreateReportDefinition403 } from "../models/AuditReportsCreateReportDefinition";

export function getAuditReportsCreateReportDefinitionUrl(reportType: AuditReportsCreateReportDefinitionPathParams["reportType"]) {
  const res = { method: 'POST', url: `/audit-reports/v1/report-definitions/${reportType}` as const }
  return res
}

/**
 * @description Creates a new report definition from the latest blueprint version for the specified report type
 * @summary Create new report definition
 * {@link /audit-reports/v1/report-definitions/:reportType}
 */
export async function auditReportsCreateReportDefinition(reportType: AuditReportsCreateReportDefinitionPathParams["reportType"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsCreateReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCreateReportDefinition400 | AuditReportsCreateReportDefinition401 | AuditReportsCreateReportDefinition403>, unknown>({ method : "POST", url : getAuditReportsCreateReportDefinitionUrl(reportType).url.toString(), ... requestConfig })
  return res.data
}